import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import { PieChart } from 'echarts/charts';
import {
  TitleComponent,
  TooltipComponent,
  LegendComponent
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { Card, CardBody, Row, Col } from 'react-bootstrap';
import { getColor } from 'helpers/utils';
import FalconCardHeader from 'components/common/FalconCardHeader';
import CardDropdown from 'components/common/CardDropdown';

echarts.use([
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer
]);

const getPieChartOption = (data, label, chartData) => {
  const formattedData = data.map(item => ({
    value: item.value,
    name: item.name
  }));

  return {
    tooltip: {
      trigger: 'item',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      textStyle: { color: getColor('gray-1100') },
      borderWidth: 1,
      transitionDuration: 0,
      formatter: '{b}: {c} ({d}%)'
    },
    legend: {
      orient: 'vertical',
      left: 'left'
    },
    series: [
      {
        name: label,
        type: 'pie',
        radius: chartData.type_look === 'pie' ? ['0%', '70%'] : ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 0
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 16,
            fontWeight: 'bold',
            color: getColor('gray-900')
          }
        },
        data: formattedData
      }
    ]
  };
};

const PieChartComponent = ({ chartData }) => {
  const [chartOption, setChartOption] = useState({});
  const { data, label } = chartData;

  useEffect(() => {
    if (data) {
      setChartOption(getPieChartOption(data, label, chartData));
    }
  }, [data, label]);

  return (
    <Card className="h-100">
      <FalconCardHeader
        title={chartData?.label}
        titleTag="h5"
        light={true}
        desc={chartData?.desc}
      />
      <CardBody>
        {chartData?.data.length > 0 ? (
          <ReactEChartsCore
            echarts={echarts}
            option={chartOption}
            style={{ minHeight: '25.75rem', width: '100%' }}
          />
        ) : (
          <Row className="align-items-center">
            <Col className="text-center">
              <div className="text-muted">No data available</div>
            </Col>
          </Row>
        )}
      </CardBody>
    </Card>
  );
};

PieChartComponent.propTypes = {
  chartData: PropTypes.shape({
    label: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired
      })
    ).isRequired,
    desc: PropTypes.any
  }).isRequired
};

export default PieChartComponent;
